export default __webpack_public_path__ + "static/result_img-ecdc945e7913765289439370114f3e2b.webp";